// extracted by mini-css-extract-plugin
export default {"input":"input_input__5m3cf","seletorQuantidadeMes":"input_seletorQuantidadeMes__tDfAj","miniSeletor":"input_miniSeletor__IRSMj"};